// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__ihTlg","words":"styles_words__ceivs","word":"styles_word__hwWDz","char":"styles_char__MVX2J","charAlt":"styles_charAlt__H_m54","arrow":"styles_arrow__AqORb"};